import type { App } from 'vue'
import { ElTooltip } from 'element-plus'
import { installI18n } from '@/locales'

const { VITE_USE_I18N } = process.env as ViteEnv

export async function registerPlugins(app: App) {
  // 加载 i18n
  if (VITE_USE_I18N) {
    await installI18n(app)
  }

  app.use(ElTooltip)
}

